<template>
  <card
    v-if="card.visible"
    :id="card.id"
    :key="card.id"
    :title="title"
    :capitalize-subtitle="card.capitalizeSubtitle"
    :subtitle-regular="subtitle"
    :class="{'card-disabled': card.disabled}"
    @click.native.prevent.stop="openNotificationBar()"
  >
    <component
      :is="card.component.name"
      v-if="card.component"
      :key="card.component.key"
      :content="card.component.content"
    />
    <infotip
      v-if="card.disabled"
      :id="card.id + '-disabled'"
      :key="card.id + '-infotip-disabled'"
      :text="card.disabledMessage || 'A funcionalidade está temporariamente em manutenção.'"
      :auto-open-on-first-days="false"
      :never-open-again-after-dismissed="false"
      :close-on-mouse-leave="true"
    />
  </card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Card from '../Card'
import Welcoming from '../Widgets/Welcoming'
import Infotip from '@/components/common/infotip/Infotip'

export default {
  name: 'WelcomeCard',
  components: {
    card: Card,
    welcoming: Welcoming,
    infotip: Infotip
  },
  computed: {
    ...mapGetters(['getMessagesNumber', 'getAlertsNumber', 'profile', 'isComunicationSidebarVisible', 'toggle']),
    subtitle: function () {
      return this.profile.laboratoryName
    },
    title: function () {
      let day = new Date()
      let hour = day.getHours()
      if (hour >= 18 && hour < 5) {
        return 'Olá! Boa noite!'
      } else if (hour >= 12 && hour < 18) {
        return 'Olá! Boa tarde!'
      } else {
        return 'Olá! Bom dia!'
      }
    },
    totalMessages: function () {
      return this.getMessagesNumber + this.getAlertsNumber
    },
    card: function () {
      return {
        id: 'welcoming',
        visible: !this.toggle.covax,
        disabled: !this.toggle.notification_view,
        capitalizeSubtitle: true,
        component: {
          name: 'welcoming',
          content: {
            number: this.toggle.notification_view === true ? this.totalMessages : 0,
            text: 'notificações não lidas',
            color: 'light-blue',
            icon: '',
            action: 'Notification'
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['setComunicationSidebarShowOff', 'changeTabShowOff']),
    openNotificationBar () {
      this.setComunicationSidebarShowOff(!this.isComunicationSidebarVisible)

      if (this.getMessagesNumber > 0) {
        this.changeTabShowOff(true)
      } else if (this.getAlertsNumber > 0) {
        this.changeTabShowOff(false)
      }
    }
  }
}
</script>
